var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date",class:[{ 'my-2': !_vm.compact }, !_vm.isDarkThemeEnabled ? 'gray-600' : '']},[(_vm.showIcon)?_c('i',{staticClass:"fa fa-clock mr-1"}):_vm._e(),_vm._v(_vm._s(_vm.stampDate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }